import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { StringValidationRule, NumberValidationRule } from '../../../../data/validation/rules'

const toNullableNumber = (value) => {
    if (value === "" || value === null || typeof value === 'undefined') {
        return null
    }
    return Number(value)
}

const getDefaultState = () => {
    return {
        creatingVisaPackage: false,
        id: null,
        name: "",
        category: "",
        keyDescription: Math.random(),
        description: "",
        price: "",
        features: "",
        featured: 0,
        status: 0,
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors
    validation.addValidationRule(StringValidationRule, instance.state.name, (error) => errors.name = error, { min: { value: 2, error: "Too short" }, max: { value: 150, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.category, (error) => errors.category = error, { min: { value: 2, error: "Too short" }, max: { value: 120, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.description, (error) => errors.description = error, { min: { value: 5, error: "Too short" }, max: { value: 100000, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.features, (error) => errors.features = error, { min: { value: 0, error: "Too short" }, max: { value: 5000, error: "Too long" } })
    validation.addValidationRule(NumberValidationRule, instance.state.price, (error) => errors.price = error, { min: { value: 0, error: "Too low" }, max: { value: 1000000000, error: "Too high" } })

    validation.addValidationRule(NumberValidationRule, instance.state.featured, (error) => errors.featured = error, { min: { value: 0, error: "Too low" }, max: { value: 1, error: "Too high" } })
    validation.addValidationRule(NumberValidationRule, instance.state.status, (error) => errors.status = error, { min: { value: 0, error: "Too low" }, max: { value: 2, error: "Too high" } })

    let validate = validation.validate()
    instance.setState({
        ...instance.state,
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    })
    return validate
}

const createVisaPackage = (instance) => {
    instance.setState({
        ...instance.state,
        creatingVisaPackage: true
    })

    const featuresArray = String(instance.state.features)
        .split('\n')
        .map(item => item.trim())
        .filter(item => item.length > 0)

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/visa-package/create",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            name: instance.state.name,
            category: instance.state.category,
            description: instance.state.description,
            price: toNullableNumber(instance.state.price),
            features: featuresArray,
            featured: Number(instance.state.featured) === 1,
            status: instance.state.status
        }
    }).then(response => handleCreateVisaPackageResponse(instance, response.data))
    .catch(error => alert(error))
}

const handleCreateVisaPackageResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }

    switch (response.status) {
        case 200:
            instance.setState({
                ...getDefaultState(),
                flag: {
                    type: "success",
                    text: "Visa Package Created"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                creatingVisaPackage: false,
                flag: {
                    type: "error",
                    text: response.message
                }
            })
    }
}

const CreateVisaPackageWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        createVisaPackage: () => createVisaPackage(instance)
    }
}

export default CreateVisaPackageWorker
